import { PaymentDeliveryOptionType } from '@routable/shared';
export const APPLICABLE_CUTOFF_WARNING_BILLING_CODES = [
    PaymentDeliveryOptionType.ACH_NEXT_DAY,
    PaymentDeliveryOptionType.ACH_SAME_DAY,
];
